// MAINTENANCE: nav, search, account links and cart removed while the backend is down.
import React from 'react'
import Headroom from 'react-headroom'
import { Link } from 'react-router-dom'
import Logo from '../assets/logo.png'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isUserLoggedIn: false
    }
  }

  componentDidMount() {
    setTimeout(
      () =>
        this.setState((state) => {
          const user = window.Snipcart.api.user.current()
          if (!state.isUserLoggedIn && user != null) {
            return {
              isUserLoggedIn: true
            }
          } else if (state.isUserLoggedIn && !user) {
            return {
              isUserLoggedIn: false
            }
          }
          return state
        }),
      1000
    )

    window.Snipcart.subscribe('authentication.success', () =>
      this.setState({ isUserLoggedIn: true })
    )

    window.Snipcart.subscribe('user.loggedout', () =>
      this.setState((state) => {
        if (state.isUserLoggedIn) {
          return {
            isUserLoggedIn: false
          }
        }
        return state
      })
    )
  }

  render() {
    return (
      <Headroom>
        <div className="header--top">
          <div className="user-info row">
            <div className="col align-center-center text-center">
              (702) 971-2484 |{' '}
              <a href="mailto:info@dogfood2mydoor.com">
                info@dogfood2mydoor.com
              </a>
            </div>
          </div>
        </div>
        <div className="header hidden-md-down">
          <div className="header__logo">
            <Link to="/">
              <img src={Logo} alt="Logo" className="logo" />
            </Link>
            <h5 className="header__logo__slogan">Locally owned - Shop Local</h5>
          </div>
          <div className="header__right-icons main-menu text-right">
            <div className="user-info row text-right">
              <div className="col align-center-center">
                <h2 style={{ color: 'white' }}></h2>
                <h2 style={{ color: 'white' }}></h2>
              </div>
            </div>
            {
              // <ul className="menu-list text-right hidden-xs-down">
              //   {this.props.main_menu.items
              //     ? mapIndexed((item, index) => (
              //         <li className="menu-item" key={index}>
              //           <Link to={item.url}>{item.title}</Link>
              //         </li>
              //       ))(this.props.main_menu.items)
              //     : null}
              // </ul>
            }
          </div>
        </div>
      </Headroom>
    )
  }
}

export default Header
